<template>
  <div class="introduction w100pc" v-wechat-title="$route.meta.title">
    <!-- 点击测评后心情打分弹窗 -->
    <van-popup v-model="showMood" @close="close()" round>
      <div class="pop1">
        <img class="pop-img1" v-lazy="resBgImg" />
        <div style="background: #fff">
          <div class="pop-title">今日心情</div>
          <div class="pop-exc">给今天的心情打个分吧</div>
          <div class="pop-imglist">
            <van-rate
              size="0.87rem"
              v-model="moodValue"
              allow-half
              void-icon="star"
              void-color="#ECEFF5"
              color="#F7B270"
            />
          </div>
        </div>

        <div class="popFt">
          <van-button type="warning" @click="submitMood()" class="popbtn"
            >确认</van-button
          >
        </div>
        <div style="text-align: center">
          <img @click="showMood = false" class="closeImg" v-lazy="closeImg" />
        </div>
      </div>
    </van-popup>
    <!-- 点击客服弹窗 -->
    <van-popup v-model="showEr" style="top: 7.5rem" @close="closeEr()" round>
      <div class="pop" style="padding: 37px 28px">
        <div
          style="
            padding-bottom: 27px;
            background: #d8e5ff;
            border-radius: 35px;
            padding: 15px;
          "
        >
          <img
            v-lazy="showPop.image"
            style="width: 6.8rem; height: auto"
            class="pop-img"
          />
          <div style="text-align: center">识别二维码，添加客服微信</div>
        </div>
      </div>
      <div style="text-align: center">
        <img
          style="height: 30px; width: 30px; margin: 28px auto"
          @click="showEr = false"
          class="closeImg"
          v-lazy="closeImg"
        />
      </div>
    </van-popup>
    <!-- 点击立即购买测评支付弹窗 -->
    <van-popup
      v-model="show"
      @close="close(0)"
      round
      position="bottom"
      closeable
    >
      <div class="pop">
        <div class="tt">
          <p class="orange f20">兑换码</p>
          <p
            v-show="!isWechat"
            @click="alis = true"
            style="margin: 18px 10px 18px 25px; color: #4a4a4a"
          >
            <img
              class="switch-tip-icon-img"
              src="https://t.alipayobjects.com/tfscom/T1Z5XfXdxmXXXXXXXX.png"
              alt="手机支付宝图标"
              style="
                width: 19px;
                height: 19px;
                vertical-align: middle;
                margin-right: 10px;
              "
            />支付宝付款
            <img
              :src="alis ? selected : select"
              style="
                width: 19px;
                height: 19px;
                vertical-align: middle;
                margin-right: 10px;
                float: right;
              "
            />
          </p>
          <p
            v-show="!isWechat"
            @click="alis = false"
            style="margin: 18px 10px 18px 25px; color: #4a4a4a"
          >
            <img
              class="switch-tip-icon-img"
              src="../../../assets/img/test/wechat.png"
              alt="微信支付图标"
              style="
                width: 19px;
                height: 19px;
                vertical-align: middle;
                margin-right: 10px;
              "
            />微信付款
            <img
              :src="alis ? select : selected"
              style="
                width: 19px;
                height: 19px;
                vertical-align: middle;
                margin-right: 10px;
                float: right;
              "
            />
          </p>
          <p class="mt-10">
            {{ testTitle }}
            <span class="fr none">
              <span class="reduce" v-if="!number"></span>
              <span class="reduce-1" @click="reduce()" v-if="number"></span>
              <span class="number">{{ number }}</span>
              <span class="add" @click="add()"></span>
            </span>
          </p>
          <hr />
          <p>
            <span class="gray">优惠券</span>
            <span v-if="!coupon.amount" class="fr">无可用优惠券</span>
            <span v-if="coupon.amount" class="fr">-￥{{ coupon.amount }}></span>
          </p>
          <p class="f20 fr mr-0 mt-20">
            合计：
            <span class="orange">￥{{ payamount }}</span>
          </p>
        </div>
        <div class="tac">
          <van-button type="default" @click="pay()" class="popbtn bgorange"
            >支付
          </van-button>
          <p class="gray mt-10 mb-10">支付成功后即可获取赠送兑换码</p>
        </div>
      </div>
    </van-popup>
    <!-- 点击立即购买测评支付弹窗 -->
    <van-popup
      v-model="showBuy"
      @close="close(2)"
      round
      position="bottom"
      closeable
    >
      <div class="pop">
        <div class="tt">
          <p class="orange f20">购买测评</p>
          <p
            v-show="!isWechat"
            @click="alis = true"
            style="margin: 18px 10px; color: #4a4a4a; margin-left: 25px"
          >
            <img
              class="switch-tip-icon-img"
              src="https://t.alipayobjects.com/tfscom/T1Z5XfXdxmXXXXXXXX.png"
              alt="手机支付宝图标"
              style="
                width: 19px;
                height: 19px;
                vertical-align: middle;
                margin-right: 10px;
              "
            />支付宝付款
            <img
              :src="alis ? selected : select"
              style="
                width: 19px;
                height: 19px;
                vertical-align: middle;
                margin-right: 10px;
                float: right;
              "
            />
          </p>
          <p
            v-show="!isWechat"
            @click="alis = false"
            style="margin: 18px 10px; color: #4a4a4a; margin-left: 25px"
          >
            <img
              class="switch-tip-icon-img"
              src="../../../assets/img/test/wechat.png"
              alt="微信支付图标"
              style="
                width: 19px;
                height: 19px;
                vertical-align: middle;
                margin-right: 10px;
              "
            />微信付款
            <img
              :src="alis ? select : selected"
              style="
                width: 19px;
                height: 19px;
                vertical-align: middle;
                margin-right: 10px;
                float: right;
              "
            />
          </p>
          <p class="mt-10">
            {{ testTitle }}
            <span class="fr none">
              <span class="reduce" v-if="!number"></span>
              <span class="reduce-1" @click="reduce()" v-if="number"></span>
              <span class="number">{{ number }}</span>
              <span class="add" @click="add()"></span>
            </span>
          </p>
          <hr />
          <p>
            <span class="gray">优惠券</span>
            <span v-if="!coupon.amount" class="fr">无可用优惠券</span>
            <span v-if="coupon.amount" class="fr">-￥{{ coupon.amount }}></span>
            <!-- <span class="fr">-￥{{coupon.amount}}<span @click="handleCouponShow()">></span></span> -->
          </p>
          <p class="f20 fr mr-0 mt-20">
            合计：
            <span class="orange">￥{{ payamount }}</span>
          </p>
        </div>
        <div class="tac">
          <van-button type="default" @click="payTest()" class="popbtn bgorange"
            >支付
          </van-button>
        </div>
      </div>
      <!-- 优惠券选项 -->
      <!-- <div class="pop" v-if="CouponShow">
              <div class="tt">
                <p class="orange f20">优惠券</p>
                <vant-form>
                  <van-field name="checkboxGroup" label="复选框组">
                    <template #input>
                      <van-checkbox-group v-model="checkboxGroup" direction="horizontal">
                        <van-checkbox name="1" shape="circle">不使用优惠券</van-checkbox>
                        <van-checkbox name="2" shape="circle">复选框 2</van-checkbox>
                      </van-checkbox-group>
                    </template>
                  </van-field>
                </vant-form>

              </div>

            </div> -->
    </van-popup>

    <!-- 兑换码相关弹窗 ddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddd-->

    <van-popup
      v-model="showCoupon"
      @close="close(1)"
      close-on-click-overlay
      class="saveRes"
      round
      style="margin-top: -20px"
    >
      <div
        ref="CodeDiv"
        v-show="firstFlag"
        class="ss pop_tacbox"
        :style="
          showImgSave
            ? 'height:535px;background:#fff'
            : 'border-radius: 32px;position: relative;'
        "
      >
        <div class="pop tac">
          <div class="pop_imgbox">
            <img v-lazy="this.headImg" ref="imgSave" />
          </div>
          <div
            style="
              background: #fff;
              padding-top: 120px;
              margin-top: -106px;
              padding-bottom: 40px;
              border-radius: 12px;
            "
          >
            <p class="f20 mt-20 pop_textTitleBox">
              <b class="pop_textTitle">{{ testTitle }}</b>
            </p>
            <p class="f16 mt-10 pop_testDiscribe">{{ testDiscribe }}</p>
            <p class="mt-5 f10 light">
              {{ testDiscribe1 }}&nbsp;&nbsp;
              <span>{{ testNum }}道精选问题</span>&nbsp;&nbsp;
              <span v-if="ReportNum == 0">专业测评报告 </span>
              <span v-else>{{ ReportNum }}字测评报告 </span>
              &nbsp;&nbsp;<span>{{ peopleNum }}人已测</span>&nbsp;
            </p>

            <div v-show="!showImgSave">
              <div class="code_box">
                <p class="code" :style="{ color: success ? '#417505' : '' }">
                  {{ code }}
                </p>
              </div>
              <van-button
                type="default"
                v-clipboard:copy="localUrl + '#/my/send/' + code"
                v-clipboard:success="copy"
                v-clipboard:error="copyError"
                class="popbtn bgblue mb-20 code_copy"
                >{{ success ? "复制成功" : "复制分享链接" }}
              </van-button>
              <van-button type="default" class="code_save" @click="closeShow"
                ><span class="code_save_icon"
                  ><img src="../../../assets/img/iconfont.png" alt="" /></span
                >生成二维码
              </van-button>
            </div>
          </div>
          <div style="text-align: center; margin-top: 20px">
            <img
              style="height: 30px; width: 30px; margin: 0 auto"
              @click="showCoupon = false"
              class="closeImg"
              v-lazy="closeImg"
            />
          </div>
          <div v-show="showImgSave" class="showImgSave">
            <div class="showImgSave_left">
              <div class="showImgSave_left_imgbox">
                <img src="../../../assets/img/logo_pic.png" alt="" />
                <p class="left_imgbox_title">酷炫脑测评</p>
              </div>
              <p class="Save_left_text">
                扫描二维码或在我的页面输入兑换码即可体验酷炫脑测评，可手动截屏分享给好友
              </p>
            </div>
            <div class="showImgSave_right">
              <div class="ma" ref="rightCode" v-show="firstFlag"></div>
              <p class="showImgSave_code">{{ code }}</p>
            </div>
          </div>
        </div>
      </div>
      <img
        :src="imgData"
        ref="resImg"
        v-show="!firstFlag"
        class="savePic pop_tacbox"
      />
    </van-popup>
    <!-- 固定icon -->
    <!-- <div class="icons">
        <div class="invite" v-show='isWechat' @click="send()">
            <img v-lazy="require('./../../../assets/img/my/send.png')" />
            <span class="f14">赠予</span>
        </div>
        <img v-lazy="require('./../../../assets/img/test/tocollect.png')" class="collect" @click.stop="collected()" v-show="!collectFlag" />
        <img v-lazy="require('./../../../assets/img/test/collected.png')" class="collect" v-show="collectFlag" @click.stop="discollect()" />
    </div>-->
    <van-popup
      v-model="showCoupon5"
      @close="close5(1)"
      close-on-click-overlay
      class="saveRes1"
      round
      style="margin-top: -20px; z-index: 1800; overflow: hidden"
      closeable
    >
      <div
        ref="CodeDiv5"
        v-show="showPng5"
        class="ss pop_tacbox CodeDiv5"
        style="
          overflow: hidden;
          height: 535px;
          max-width: 90vw;
          background: #fff;
          padding-top: 35px;
          position: relative;
        "
      >
        <div class="pop tac">
          <!-- <div>
                    <img src="../../../assets/img/logo_pic.png" alt="" />
                    酷炫脑测评
                </div> -->
          <div
            style="position: absolute; top: 14px; left: 14px; text-align: left"
          >
            <img
              style="
                width: 117px;
                height: 34px;
                vertical-align: middle;
                margin-top: -2px;
              "
              src="data:image/png;base64,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"
            />
            <!-- <img style='width:117px;vertical-align: middle;margin-top: -2px;' src="require('../../../assets/img/title.png')" /> -->
          </div>
          <div class="pop_imgbox">
            <img
              :src="headImg5 + '?any_string_is_ok'"
              ref="img"
              id="imgId"
              crossorigin="anonymous"
            />
          </div>
          <div
            style="
              background: #fff;
              padding-top: 120px;
              margin-top: -106px;
              padding-bottom: 40px;
              border-radius: 12px;
            "
          >
            <p class="f20 mt-20 pop_textTitleBox">
              <b class="pop_textTitle">{{ testTitle5 }}</b>
            </p>
            <p class="f16 mt-10 pop_testDiscribe">{{ testDiscribe5 }}</p>
            <p class="mt-5 f10 light">
              {{ testDiscribe15 }}&nbsp;&nbsp;
              <span>{{ testNum5 }}道精选问题</span>&nbsp;&nbsp;
              <span v-if="ReportNum5 == 0">专业测评报告 </span>
              <span v-else>{{ ReportNum5 }}字测评报告 </span>
              &nbsp;&nbsp;<span>{{ peopleNum5 }}人已测</span>&nbsp;
            </p>
          </div>

          <div class="showImgSave">
            <div class="showImgSave_left">
              <!-- <div class="showImgSave_left_imgbox">
                            <img src="../../../assets/img/logo_pic.png" alt="" />
                            <p class="left_imgbox_title">酷炫脑测评</p>
                        </div> -->
              <div class="showImgSave_left_imgbox">
                <img :src="user.avatar" alt="" />
                <p class="left_imgbox_title">
                  {{
                    user.nick_name && user.nick_name.length > 10
                      ? user.nick_name.slice(0, 10) + "..."
                      : user.nick_name
                  }}
                </p>
              </div>
              <p class="Save_left_text">
                “ 嗨～ 扫描右侧二维码， 一起加入测试吧。”
              </p>
            </div>
            <div class="showImgSave_right">
              <div class="ma" ref="rightCode"></div>
            </div>
          </div>
        </div>
        <!-- <div style='text-align: center;'>
                    <img style='height: 30px; width: 30px; margin: 0 auto;' @click='showCoupon=false' class="closeImg" v-lazy="closeImg" />
                </div> -->
      </div>
      <img :src="imgData5" ref="resImg" class="savePic pop_tacbox" />
    </van-popup>
    <!-- 客服 -->
    <div
      style="
        position: absolute;
        right: 24px;
        top: 28px;
        z-index: 100;
        color: #fff;
        background-color: rgba(0, 0, 0, 0.5);
        border-radius: 5px;
        padding: 3px;
      "
      @click.stop="openEr()"
    >
      <img
        style="height: 24px; width: 24px"
        v-lazy="require('./../../../assets/img/test/kefu.png')"
      />
      <div
        style="
          color: #fff;
          font-size: 9px;
          font-family: SourceHanSansCN-Regular, SourceHanSansCN;
          font-weight: 400;
          color: #ffffff;
        "
      >
        客服
      </div>
    </div>
    <!-- 分享 -->
    <!-- <div
      @click="showImg5"
      style="
        position: fixed;
        right: 24px;
        bottom: 70px;
        z-index: 100;
        color: #fff;
        text-align: center;
      "
    >
      <img
        style="height: 50px; width: 43px"
        v-lazy="require('./../../../assets/img/test/gift-box.png')"
      />
      <div
        style="
          margin-top: 5px;
          line-height: 20px;
          padding: 0px 4px;
          background: linear-gradient(to left, #fe6f28, #f6a624);
          font-size: 12px;
          font-family: SourceHanSansCN-Regular, SourceHanSansCN;
          font-weight: 400;
          color: #ffffff;
          border-radius: 5px;
        "
      >
        分享得￥{{ gold }}元
      </div>
    </div> -->
     <span class="collects" @click.stop="collected()" v-show="!collectFlag">
          <img
            style="
              width: 15px;
              height: 13px;
              margin-right: 5px;
              vertical-align: middle;
            "
            v-lazy="require('./../../../assets/img/test/heart.png')"
            class="collect"
          />

          收藏</span
        >
        <span class="collects" v-show="collectFlag" @click.stop="discollect()">
          <img
            style="
              width: 15px;
              height: 13px;
              margin-right: 5px;
              vertical-align: middle;
            "
            v-lazy="require('./../../../assets/img/test/favorited.png')"
            class="collect"
          />

          收藏</span
        >
    <!-- 赠送 -->
    <div
      @click="send()"
      style="
        text-align: center;
        border-radius: 18px 0px 0px 18px;
        position: absolute;
        right: 0;
        top: calc(0.55 * 100vw);
        z-index: 100;
        background: #f5a623;
        width: 64px;
        height: 28px;
      "
    >
      <div
        style="
          color: #fff;
          line-height: 28px;
          font-size: 13px;
          font-family: SourceHanSansCN-Regular, SourceHanSansCN;
          font-weight: 400;
          color: #ffffff;
        "
      >
        赠送好友
      </div>
    </div>

    <!-- 头图 -->
    <div class="imgbg">
      <img v-lazy="bgimg" class="head img" />
    </div>
    <div class="title ml-20" style="margin-top: 22px">
      <div
        style="
          margin-bottom: 12px;
          display: flex;
          justify-content: space-between;
        "
      >
        <b>{{ testTitle }}</b>
        <!-- <p style=''> -->
        <div style="margin-right: 5%">
          <span class="orange">￥{{ discount }}</span>
          <s class="f14 ml-5">￥{{ price }}</s>
        </div>
        <!-- </p> -->
      </div>
      <p class="mt-5 lh12" style="font-size: 15px">{{ testDiscribe }}</p>
      <p class="mt-10" style="font-size: 13px; position: relative">
        {{ testDiscribe1 }}
        <span>{{ testNum }}道精选问题</span>&nbsp;&nbsp;
        <!--                <span>专业测 评报告</span>&nbsp;&nbsp;-->
        <span v-if="ReportNum == 0">专业测评报告 </span>
        <span v-else>{{ ReportNum }}字测评报告</span>
        &nbsp;&nbsp;<span>{{ peopleNum }}人已测</span>&nbsp;&nbsp;
       
      </p>
      <!-- <p style='position:relative'>
            <img style='width:87vw;' v-lazy="this.helpImg" />
            <img @click='goHelp()' style='width: calc(0.117 * 100vw);
    position: absolute;
    right: calc(0.11 * 100vw);
    top: calc(0.086 * 100vw);' v-lazy="this.goImg" />
        </p> -->
    </div>
    <!-- /////////////////////////////////////////////////////////// -->
    <div class="mb-10 imgbox">
      <img v-for="(item, index) in imgList" v-lazy="item.image" :key="index" />
      <img src="../../../assets/img/appoint_query.png" />
      <div class="wx_id">微信号: brain_assisstant1</div>
    </div>
    <!-- ///////////////////////////////////////////////// -->
    <div class="mt-20 mb-20" style="padding-bottom: 50px">
      <p class="ml-20 mb-20 f18" style="margin-bottom: 36px">
        用户评价
        <!-- todo -->
        <span class="fr mr-10 f14 check_more_box_rect" @click="goAllComment()">
          <div class="check_more_test" style="color: #42686e">
            查看更多<img
              style="width: 7px; height: 9px; margin-left: 1px; font-size: 18px"
              v-lazy="require('../../../assets/img/test/right.png')"
            />
          </div>
        </span>
      </p>
      <Comment
        v-for="(item, index) in commentList"
        :key="index"
        :item="item"
      ></Comment>
      <van-button
        type="default"
        @click="goAllComment()"
        class="allbtn f16 mb-20"
        style="margin-bottom: 50px"
        >查看全部评价&nbsp;>
      </van-button>
    </div>
    <!-- 返回首页icon -->
    <!-- <div class="bottom homeIcon">
        <img v-lazy="require('./../../../assets/img/my/home-act.png')" class="home" @click="goHome" />
    </div> -->
    <!--抖音支付 -->
    <div v-if="douyin">
      <div
        v-if="isFinished == 'no'"
        class="rebuyBox orange bottom"
        style="background-color: white"
      >
        <div
          style="
            line-height: 16px;
            text-align: center;
            font-size: 13px;
            color: #4a4a4a;
            padding-top: 6px;
          "
        >
          <img
            v-lazy="require('./../../../assets/img/my/home-act.png')"
            class="home"
            style="width: 25px"
            @click="goHome"
          />
          <div>主页</div>
        </div>
        <div
          class="rebuy"
          @click="startTest()"
          style="
            font-size: 18px;
            font-weight: 500;
            padding: 0 3rem;
            background: #42686e;
          "
        >
          体验测评
        </div>
      </div>
      <div
        v-else
        class="rebuyBox orange bottom"
        style="background-color: white"
      >
        <div
          style="
            line-height: 16px;
            text-align: center;
            font-size: 13px;
            color: #4a4a4a;
            padding-top: 6px;
            margin-right: 12px;
          "
        >
          <img
            v-lazy="require('./../../../assets/img/my/home-act.png')"
            class="home"
            style="width: 25px"
            @click="goHome"
          />
          <div>主页</div>
        </div>
        <div
          style="
            line-height: 16px;
            text-align: center;
            font-size: 13px;
            color: #4a4a4a;
            padding-top: 6px;
            margin-right: 7px;
          "
        >
          <img
            v-lazy="require('./../../../assets/img/my/report.png')"
            class="home"
            style="width: 19px"
            @click="goResult"
          />
          <div>报告</div>
        </div>
        <div
          class="rebuy"
          @click="buyTest"
          style="font-size: 18px; font-weight: 500"
        >
          ¥{{ discount }}<span class="ogPrice">¥{{ price }}</span
          >{{ discount <= 3 ? "限时体验" : "立即购买" }}
        </div>
      </div>
    </div>
    <!-- 非会员购买 -->
    <div v-if="!isVip && !can_create && !douyin">
      <div
        v-if="isFinished == 'no'"
        class="rebuyBox orange bottom fcc"
        style="background-color: white"
      >
        <!-- <span class="vip"></span>
            <b @click="tobeVip()" class="txt1 f14">会员免费测></b>
            <span class="right mr-5">
                <span class="f8">￥</span>
                <b class="f20">{{ discount }}</b>
                <s class="gray f14">
                    <span class="f8">￥</span>
                    {{ price }}
                </s>
            </span>
            <button @click="buyTest()" class="btn">
                <span class="f16">立即购买</span>
            </button> -->
        <div
          style="
            line-height: 16px;
            text-align: center;
            font-size: 13px;
            color: #4a4a4a;
            padding-top: 6px;
            margin-right: 12px;
          "
        >
          <img
            v-lazy="require('./../../../assets/img/my/home-act.png')"
            class="home"
            style="width: 25px"
            @click="goHome"
          />
          <div>主页</div>
        </div>
        <div
          style="
            line-height: 16px;
            text-align: center;
            font-size: 13px;
            color: #f5a623;
            padding-top: 6px;
            margin-right: 7px;
          "
        >
          <img
            v-lazy="require('./../../../assets/img/my/vipicon.png')"
            class="home"
            style="width: 25px"
            @click="tobeVip()"
          />
          <div>会员免费测</div>
        </div>
        <div class="rebuy" @click="buyTest">
          ¥{{ discount }}<span class="ogPrice">¥{{ price }}</span
          >{{ discount <= 3 ? "体验测评" : "立即购买" }}
        </div>
      </div>

      <div
        v-else
        class="rebuyBox orange bottom fcc"
        style="background-color: white"
      >
        <div
          style="
            line-height: 16px;
            text-align: center;
            font-size: 13px;
            color: #4a4a4a;
            padding-top: 6px;
            margin-right: 30px;
          "
        >
          <img
            v-lazy="require('./../../../assets/img/my/home-act.png')"
            class="home"
            style="width: 25px"
            @click="goHome"
          />
          <div>主页</div>
        </div>
        <div
          style="
            line-height: 16px;
            text-align: center;
            font-size: 13px;
            color: #4a4a4a;
            padding-top: 6px;
            margin-right: 31px;
          "
        >
          <img
            v-lazy="require('./../../../assets/img/my/report.png')"
            class="home"
            style="width: 19px"
            @click="goResult"
          />
          <div>报告</div>
        </div>
        <div class="rebuy" @click="buyTest">
          ¥{{ discount }}<span class="ogPrice">¥{{ price }}</span
          >{{ discount <= 3 ? "体验测评" : "再次购买" }}
        </div>
        <!-- <div class="viewReport" @click="goResult">查看报告</div> -->
      </div>
    </div>
    <!-- 会员购买 -->
    <div v-if="isVip && !member_free && !can_create && !douyin">
      <div
        v-if="isFinished == 'no'"
        class="rebuyBox orange bottom"
        style="background-color: white"
      >
        <div
          style="
            line-height: 16px;
            text-align: center;
            font-size: 13px;
            color: #4a4a4a;
            padding-top: 6px;
          "
        >
          <img
            v-lazy="require('./../../../assets/img/my/home-act.png')"
            class="home"
            style="width: 25px"
            @click="goHome"
          />
          <div>主页</div>
        </div>
        <div
          class="rebuy"
          @click="buyTest"
          style="font-size: 18px; font-weight: 500; padding: 0 1.2rem"
        >
          ¥{{ discount }}<span class="ogPrice">¥{{ price }}</span>
          {{ discount <= 3 ? "体验测评" : "会员价购买" }}
        </div>
      </div>
      <div
        v-else
        class="rebuyBox orange bottom"
        style="background-color: white"
      >
        <div
          style="
            line-height: 16px;
            text-align: center;
            font-size: 13px;
            color: #4a4a4a;
            padding-top: 6px;
            margin-right: 12px;
          "
        >
          <img
            v-lazy="require('./../../../assets/img/my/home-act.png')"
            class="home"
            style="width: 25px"
            @click="goHome"
          />
          <div>主页</div>
        </div>
        <div
          style="
            line-height: 16px;
            text-align: center;
            font-size: 13px;
            color: #4a4a4a;
            padding-top: 6px;
            margin-right: 7px;
          "
        >
          <img
            v-lazy="require('./../../../assets/img/my/report.png')"
            class="home"
            style="width: 19px"
            @click="goResult"
          />
          <div>报告</div>
        </div>
        <div
          class="rebuy"
          @click="buyTest"
          style="font-size: 18px; font-weight: 500"
        >
          ¥{{ discount }}<span class="ogPrice">¥{{ price }}</span
          >{{ discount <= 3 ? "体验测评" : "再次购买" }}
        </div>
      </div>
    </div>
    <!-- 会员免费测 -->
    <div v-if="isVip && member_free && can_create && !douyin">
      <div class="rebuyBox orange bottom" style="background-color: white">
        <div
          style="
            line-height: 16px;
            text-align: center;
            font-size: 13px;
            color: #4a4a4a;
            padding-top: 6px;
          "
        >
          <img
            v-lazy="require('./../../../assets/img/my/home-act.png')"
            class="home"
            style="width: 25px"
            @click="goHome"
          />
          <div>主页</div>
        </div>
        <div
          class="rebuy"
          @click="startTest()"
          style="font-size: 18px; font-weight: 500; padding: 0 1.8rem"
        >
          会员用户 免费测评
        </div>
      </div>
    </div>
    <div v-if="isVip && member_free && !can_create && !douyin">
      <div class="rebuyBox orange bottom" style="background-color: white">
        <div
          style="
            line-height: 16px;
            text-align: center;
            font-size: 13px;
            color: #4a4a4a;
            padding-top: 6px;
          "
        >
          <img
            v-lazy="require('./../../../assets/img/my/home-act.png')"
            class="home"
            style="width: 25px"
            @click="goHome"
          />
          <div>主页</div>
        </div>
        <div
          class="rebuy"
          @click="startTest()"
          style="font-size: 18px; font-weight: 500; padding: 0 1.8rem"
        >
          会员用户 免费测评
        </div>
      </div>
    </div>
    <!-- <van-button class="bgorange w90btn fff bdr25 orange2white" v-if="isVip && member_free && can_create" @click="startTest()">会员用户 免费测评
    </van-button> -->
    <!-- 会员已购-开始测 -->
    <div v-if="isVip && !member_free && can_create && !douyin">
      <div class="rebuyBox orange bottom" style="background-color: white">
        <div
          style="
            line-height: 16px;
            text-align: center;
            font-size: 13px;
            color: #4a4a4a;
            padding-top: 6px;
            margin-left: 4px;
          "
        >
          <img
            v-lazy="require('./../../../assets/img/my/home-act.png')"
            class="home"
            style="width: 25px"
            @click="goHome"
          />
          <div>主页</div>
        </div>
        <div
          @click="startTest()"
          class="rebuy"
          style="
            font-size: 18px;
            font-weight: 500;
            padding: 0 3rem;
            background: #42686e;
          "
        >
          开始测评
        </div>
      </div>
    </div>
    <!-- <van-button class="w90btn bgblue fff bdr25" v-if="isVip && !member_free && can_create" @click="startTest()">开始测评
    </van-button> -->
    <div v-if="(!isVip && !douyin && can_create) || discount == 0">
      <div class="rebuyBox orange bottom" style="background-color: white">
        <div
          style="
            line-height: 16px;
            text-align: center;
            font-size: 13px;
            color: #4a4a4a;
            padding-top: 6px;
            margin-left: 4px;
          "
        >
          <img
            v-lazy="require('./../../../assets/img/my/home-act.png')"
            class="home"
            style="width: 25px"
            @click="goHome"
          />
          <div>主页</div>
        </div>
        <div
          class="rebuy"
          @click="startTest()"
          style="
            font-size: 18px;
            font-weight: 500;
            padding: 0 3rem;
            background: #42686e;
          "
        >
          开始测评
        </div>
      </div>
    </div>
    <!-- <van-button class="w90btn bgblue fff bdr25" v-if="!isVip && can_create||discount == 0" @click="startTest()">开始测评
    </van-button> -->
  </div>
</template>

<script>
import Comment from "@/components/Comment";
import store from "./../../../store/index";
import RelatedTest from "@/components/RelatedTest";
import { mapGetters } from "vuex";
import QRCode from "qrcodejs2";
// import html2canvas from "./../../../utils/html2canvas";
import html2canvas from "html2canvas";
import { Loading } from "element-ui";
import sdk from "../../../mixin/share";
import imageUtil from "../../../utils/imagesale.js";
import {
  getTestDetail,
  getTestCommets,
  sendTest,
  collectTest,
  cancelCollect,
  paychase,
  h5paychase,
  getUserInfo,
  testCoupon,
  getMood,
  sendMood,
} from "@/http/api";

export default {
  name: "introduction",
  data() {
    return {
      douyin: false,
      // 弹窗相关
      showPng5: true,
      showCoupon5: false,
      eval_id5: "",
      headImg5: "",
      testTitle5: "",
      testDiscribe5: "",
      testDiscribe15: "",
      testNum5: 0,
      ReportNum5: 0,
      closeImg5: require("./../../../assets/img/test/close.png"),
      peopleNum5: 0,
      imgData5: "",
      showMood: false,
      moodValue: 0,
      show: false,
      showEr: false,
      localUrl: "",
      number: 1,
      showCoupon: false, // 赠送测评弹窗
      alis: true,
      success: false,
      code: "",
      showBuy: false,
      collectFlag: false,
      active: 0,
      isFinished: "no",
      appraisal_id: "",
      eval_id: "",
      collect_id: "",
      headImg: "",
      testTitle: "",
      islike: true,
      testDiscribe: "",
      testDiscribe1: "",
      testNum: 0, // 测评题目数
      ReportNum: 0, // 报告页数
      peopleNum: 0, // 测试人数
      discount: 0, // 折扣后价格
      gold: 0,
      price: 0, // 原价
      testIntro: "",
      helpImg: require("./../../../assets/img/test/helpme.png"),
      goImg: require("./../../../assets/img/test/go.png"),
      imgList: [require("./../../../assets/img/test/intro.png")],
      commentList: [],
      showPop: {
        image: require("./../../../assets/img/test/erweima.png"),
      },
      payamount: "", // 优惠券抵消后支付价格
      couponFlag: "", // 支付是否使用优惠券
      coupon: {},
      isVip: false,
      // 会员免费
      member_free: false,
      // 是否可以创建测评
      can_create: false,
      //兑换窗保存图片
      showImgSave: false,
      resBgImg: require("./../../../assets/img/test/mood.png"),
      closeImg: require("./../../../assets/img/test/close.png"),
      firstFlag: true,
      hdimg: "",
      imgData: "",
      dataurl: "",
      imagewidth: 0,
      imageheight: 0,
      showScleImg: false,
      bgimg: "",
      CouponShow: false,
      checkboxGroup: [],
      isWechat: "",
      inviter_id: "",
      select: require("./../../../assets/img/test/select.png"),
      selected: require("./../../../assets/img/test/selected.png"),
    };
  },
  components: {
    Comment,
    RelatedTest,
  },
  computed: {
    ...mapGetters(["user"]),
  },
  watch: {
    showCoupon(val) {
      this.showCoupon = val;
    },
  },
  created() {
    localStorage["first"] = "";
    localStorage["douyin"] = "";
    this.eval_id5 = this.$route.path.match(/\d+/)[0];
    this.douyin = window.location.href.split("douyin=")[1] ? true : false;
    getTestDetail(this.eval_id5).then((res) => {
      this.headImg5 = res.data.home_image;
      this.testTitle5 = res.data.title;
      this.testDiscribe5 = res.data.intro;
      this.testDiscribe15 = res.data.intro_text;
      this.testNum5 = res.data.question_list.length;
      this.ReportNum5 = res.data.report_num;
      this.peopleNum5 = res.data.evaluation_times;
    });
    const ua = window.navigator.userAgent.toLowerCase();
    this.isWechat = ua.match(/MicroMessenger/i) == "micromessenger";
    getMood().then((res) => {
      this.showMood = !res.data.is_clock;
    });
    console.log(this.$route.path);
    this.inviter_id = window.location.href.split("user_id=")[1] || "";
    console.log(this.inviter_id);
    this.eval_id = this.$route.path.match(/\d+/)[0];
    store.commit("set_eval_id", this.eval_id);
    console.log("this.user");
    console.log(this.user);
    if (this.user.nick_name) {
      getUserInfo(this.user.user).then((res) => {
        console.log("用户信息", res);
        const payload = res.data.profile;
        store.commit("updateUser", payload);
        this.isVip = res.data.profile.is_vip.key === "yes";
        // this.isVip=false
        // console.log("this.isVip", this.isVip);
      });
    }
    console.log(this.user);
    getTestDetail(this.eval_id)
      .then((res) => {
        console.log("jinlai");
        this.headImg = res.data.home_image;
        this.bgimg = res.data.detail_image;
        // this.headImg = require('./../../../assets/img/test/intro.png')
        this.testTitle = res.data.title;
        this.testDiscribe = res.data.intro;
        this.price = res.data.original_price;
        this.imgList = res.data.intro_image;
        console.log("this.imgList", this.imgList[0].image);
        this.testDiscribe1 = res.data.intro_text;
        this.peopleNum = res.data.evaluation_times;
        this.ReportNum = res.data.report_num;
        // this.ReportNum = 100
        this.collectFlag = res.data.is_collected;
        this.collect_id = res.data.collect_id;
        this.can_create = res.data.can_create;
        this.member_free = res.data.member_free.key === "yes";
        this.testNum = res.data.question_list.length;

        this.$route.meta.title = res.data.title;
        this.$store.commit("setIntro", res.data.title);
        console.log(this.$store.state.introduction);

        console.log("测评的详细信息", res);

        if (res.data.exist_appraisal) {
          this.isFinished = res.data.exist_appraisal.is_finished;
          this.appraisal_id = res.data.exist_appraisal.id;
          store.commit("set_appraisal_id", this.appraisal_id);
        }
        this.discount = parseFloat(res.data.discount_price);
        this.gold = parseFloat(res.data.gold || 0);
        let param = {
          amount: this.discount,
        };
        testCoupon(param).then((res1) => {
          if (res1.data.hasOwnProperty("coupon")) {
            console.log("优惠券", res1.data.coupon);
            this.couponFlag = true;
            this.coupon = res1.data.coupon;
            this.coupon.id = res1.data.id;
          }
          if (res.data.discount_price) {
            this.payamount = this.checkCoupon(this.discount);
          } else {
            this.payamount = this.checkCoupon(this.price);
          }
        });
        const appraisal_id = store.state.appraisal_id;
        const Img = this.user ? this.user.avatar : "";
        const Name = this.user ? this.user.nick_name : "";
        // var ProjectName=encodeURI(Name)
        const ISVip = this.user ? this.user.is_vip.key === "yes" : false;
        const url = window.location.href.split("#")[0];
        this.localUrl = url;
        const dataForWeixin = {
          title: res.data.title, // 分享标题
          desc: res.data.intro, // 分享内容
          linkurl: `${url}#/test/${this.eval_id}/introduction?type=share`, // 分享链接
          img: res.data.home_image, // 分享内容显示的图片(图片必须是正方形的链接)
        };
        const ua = window.navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == "micromessenger") {
          sdk.getJSSDK(dataForWeixin);
        }
      })
      .catch((err) => {
        console.log(err);
      });
    let params = {
      page: 1,
      page_size: 20,
      evaluation: this.eval_id,
    };
    getTestCommets(params).then((res) => {
      this.commentList = res.data.objects;
    });
  },
  methods: {
    getBase64Image5(img) {
      var canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;

      var ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, img.width, img.height);
      var ext = img.src.substring(img.src.lastIndexOf(".") + 1).toLowerCase();
      var dataURL = canvas.toDataURL("image/" + ext);
      return dataURL;
    },

    close5() {
      this.showCoupon5 = false;
      this.$refs.rightCode = "";
    },
    showImg5() {
      this.showCoupon5 = true;
      this.$nextTick(() => {
        this.bindQRCode5();
      });
    },
    bindQRCode5() {
      let t = this;
      console.log("this.$refs", this.$refs.rightCode);
      console.log("this.eval_id", this.eval_id);
      const url = window.location.href.split("#")[0];
      this.localUrl = url;
      // let url = window.location.href.split("#")[0];
      new QRCode(this.$refs.rightCode, {
        text:
          "http://h5.coolbrainscience.cn/#/test/" +
          this.eval_id +
          "/introduction?user_id=" +
          this.user.user,
        // text: this.localUrl + "#/my/send/" + this.code,
        width: this.$refs.rightCode.clientWidth - 8,
        height: this.$refs.rightCode.clientHeight - 8,
        colorDark: "#42686E", // 二维码颜色
        colorLight: "#ffffff", // 二维码背景色
        correctLevel: QRCode.CorrectLevel.L, // 容错率，L/M/H
      });
      // this.createPicture5();
    },
    createPicture5() {
      window.scrollTo(0, 0);
      window.pageYoffset = 0;

      document.documentElement.scrollTop = 0;

      document.body.scrollTop = 0;
      let content = this.$refs.CodeDiv5;
      console.log(this.$refs.CodeDiv5);
      let width = content.offsetWidth;
      let height = content.offsetHeight;
      let scale = window.devicePixelRatio;

      let shareContent = document.getElementsByClassName("saveRes1")[0];
      //  console.log(shareContent)
      const rect = shareContent.getBoundingClientRect();
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop; // 获取滚动轴滚动的长度
      // alert(rect.top)
      //  alert(rect.left)
      // alert(scale)
      //  alert(window.pageyoffset)
      let opt = {
        useCORS: true,
        tainttest: true,
        backgroundColor: "#ECEFF5",
        width: Math.round(width),
        height: Math.round(height),
        scale: scale,
        x: 19,
        y: 38,
        scrollX: 0,
        // scrollY: 0,
        scrolly: 0,
        logging: true,
      };
      // console.log(this.$refs);
      // console.log(opt)
      let loadingInstance = Loading.service({
        fullscreen: true,
        text: "生成分享图片中...",
      });
      window.pageYOffset = 0;
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      // setTimeout(function () {
      setTimeout(() => {
        html2canvas(document.getElementsByClassName("CodeDiv5")[0], opt)
          .then((canvas) => {
            this.firstFlag5 = false;
            console.log("生成");
            var imgData5 = canvas.toDataURL("image/jpeg");
            this.imgData5 = imgData5;
            this.showPng5 = false;
            loadingInstance.close();
          })
          .catch((error) => {
            loadingInstance.close();
            console.log("错误", error);
          });
      }, 1000);

      // }, 1000);
    },
    //top
    submitMood() {
      if (!this.moodValue) {
        // Message({ message: '心情提交失败', type: 'error' });
        return;
      }
      this.showMood = false;
      let param = {
        mood: this.moodValue,
      };
      sendMood(param)
        .then((res) => {
          console.log(11);
        })
        .catch((err) => {
          Message({
            message: "心情提交失败",
            type: "error",
          });
        });
    },
    // 优惠券
    handleCouponShow() {
      this.CouponShow = true;
    },
    // 生成二维码
    closeShow() {
      this.showImgSave = true;
      this.$nextTick(() => {
        this.bindQRCode();
      });
    },
    bindQRCode() {
      let t = this;
      console.log("this.$refs", this.$refs);
      console.log("this.eval_id", this.eval_id);
      // let url = window.location.href.split("#")[0];
      new QRCode(this.$refs.rightCode, {
        // text: "http://h5.coolbrainscience.cn/#/test/" +
        // 	this.eval_id +
        // 	"/introduction",
        text: this.localUrl + "#/my/send/" + this.code,
        width: this.$refs.rightCode.clientWidth - 8,
        height: this.$refs.rightCode.clientHeight - 8,
        colorDark: "#42686E", // 二维码颜色
        colorLight: "#ffffff", // 二维码背景色
        correctLevel: QRCode.CorrectLevel.L, // 容错率，L/M/H
      });
      this.createPicture();
    },
    createPicture() {
      console.log(111);
      window.scrollTo(0, 0);
      let content = this.$refs.CodeDiv;
      console.log(this.$refs.CodeDiv);
      let width = content.offsetWidth;
      let height = content.offsetHeight;
      let scale = window.devicePixelRatio;

      let shareContent = document.getElementsByClassName("saveRes")[0];
      //  console.log(shareContent)
      const rect = shareContent.getBoundingClientRect();
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop; // 获取滚动轴滚动的长度
      let opt = {
        useCORS: true,
        tainttest: true,
        backgroundColor: "#ECEFF5",
        width: Math.round(width),
        height: Math.round(height),
        scale: scale,
        x: rect.left,
        y: rect.top,
        scrollX: 0,
        scrollY: 0,
        logging: true,
      };
      console.log(opt);
      setTimeout(function () {
        html2canvas(this.$refs.CodeDiv, opt)
          .then((canvas) => {
            this.firstFlag = false;
            console.log("生成");
            var imgData = canvas.toDataURL("image/jpeg");
            this.imgData = imgData;
          })
          .catch((error) => {
            console.log("错误", error);
          });
      }, 1000);
    },
    // 优惠券
    checkCoupon(price) {
      let payamount = price;
      if (parseFloat(this.coupon.usage_condition) <= price) {
        payamount = (this.discount - this.coupon.amount).toFixed(2);
        this.couponFlag = true;
        if (payamount < 0) {
          payamount = 0;
        }
      }
      console.log(price, payamount, this.coupon);
      return payamount;
    },
    // 弹窗
    add() {
      this.number = this.number + 1;
    },
    reduce() {
      if (this.number > 0) {
        this.number = this.number - 1;
      }
    },

    close(i) {
      if (!i) {
        this.show = false;
      } else {
        this.showCoupon = false;
      }
    },
    closeEr() {
      this.showEr = false;
    },
    openEr() {
      this.showEr = true;
    },
    // 赠送-购买测评
    pay() {
      console.log(localStorage["env"]);
      const ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) != "micromessenger") {
        // if(localStorage['env'] == 'notWechat'){
        let param = {
          pay_type: "present",
          payment: this.alis ? "ali_pay" : "wechat_pay",
          evaluation: this.eval_id,
          amount: this.payamount,
          inviter_id: this.inviter_id,
        };
        if (this.couponFlag) {
          param.coupon_id = this.coupon.id;
        }
        h5paychase(param).then((res) => {
          if (res.code == "SUCCESS") {
            console.log(res.data.pay_url);
            if (res.data.pay_url) {
              window.location.replace(res.data.pay_url);
            }
          }
        });
      } else {
        let param = {
          pay_type: "present",
          evaluation: this.eval_id,
          amount: this.payamount,
          inviter_id: this.inviter_id,
        };
        if (this.couponFlag) {
          param.coupon_id = this.coupon.id;
        }
        paychase(param).then((res) => {
          console.log("详情页的支付", res);
          if (parseFloat(this.payamount) == parseFloat(0)) {
            this.code = res.data.redeem_code;
            setTimeout(() => {
              this.show = false;
              this.showCoupon = true;
              // console.log(this.showCoupon);
            }, 1000);
            // return
          } else {
            let data = res.data.pay_params;
            let appId = data.appId;
            let timeStamp = data.timeStamp;
            let nonceStr = data.nonceStr;
            let signature = data.signature;
            let packages = data.package;
            let paySign = data.paySign;
            this.code = res.data.redeem_code;
            WeixinJSBridge.invoke(
              "getBrandWCPayRequest",
              {
                appId: appId, //公众号名称，由商户传入
                timeStamp: timeStamp, //时间戳，自1970年以来的秒数
                nonceStr: nonceStr, //随机串
                package: packages,
                signType: "MD5", //微信签名方式：
                paySign: paySign, //微信签名
              },
              (res) => {
                if (res.err_msg == "get_brand_wcpay_request:ok") {
                  this.$message({
                    message: this.code + "支付成功",
                    type: "success",
                  });
                  let coupon = {
                    amount: 0,
                    condition: 0,
                  };
                  store.commit("set_coupon", coupon);
                  setTimeout(() => {
                    this.show = false;
                    this.showCoupon = true;
                    console.log(this.showCoupon);
                  }, 1000);
                } else if (res.err_msg === "get_brand_wcpay_request:cancel") {
                  this.$message({
                    message: "您已取消支付",
                    type: "error",
                  });
                } else {
                  this.$message({
                    message: "支付失败",
                    type: "error",
                  });
                }
              }
            );
          }
        });
      }
      // }

      // }
    },
    // 复制兑换码
    copy(e) {
      console.log("复制成功", e);
      this.success = true;
    },
    copyError(e) {
      console.log("复制失败", e);
      this.success = false;
    },
    goGold() {
      this.$router.push("./testGold");
    },
    goHelp() {
      this.$router.push("./../../my/help");
    },
    // 查看全部评价
    goAllComment() {
      this.$router.push("./userComment");
    },
    // 成为会员
    tobeVip() {
      if (!localStorage["site_current_token"]) {
        localStorage["url"] = this.eval_id;
        if (this.douyin) {
          localStorage["douyin"] = 1;
        }
        this.$router.push("/login");
      } else {
        this.$router.push("./../../my/vip");
      }
    },
    // 开始测评
    startTest() {
      if (!localStorage["site_current_token"]) {
        localStorage["url"] = this.eval_id;
        if (this.douyin) {
          localStorage["douyin"] = 1;
        }
        this.$router.push("/login");
      } else {
        this.$router.push("./gender");
      }

      // if (this.isFinished !== 'no') {
      //   this.$router.push('./detail')
      // } else {

      // }
    },
    // 查看结果
    goResult() {
      this.$router.push("./../" + this.appraisal_id + "/result");
    },
    // 赠送测评
    send() {
      if (!localStorage["site_current_token"]) {
        localStorage["url"] = this.eval_id;
        if (this.douyin) {
          localStorage["douyin"] = 1;
        }
        this.$router.push("/login");
      }
      this.toBottom(500);
      this.show = true;
    },
    // 收藏测评
    collected() {
      let param = {
        evaluation: this.eval_id,
      };
      collectTest(param).then((res) => {
        console.log("收藏测评", res);
        this.collectFlag = true;
        this.collect_id = res.data.id;
      });
    },
    // 取消收藏
    discollect() {
      let param = {
        id: this.collect_id,
      };
      cancelCollect(param).then((res) => {
        this.collectFlag = false;
        console.log("取消收藏", this.collectFlag, res);
      });
    },
    // 购买测评
    buyTest() {
      if (!localStorage["site_current_token"]) {
        localStorage["url"] = this.eval_id;
        if (this.douyin) {
          localStorage["douyin"] = 1;
        }
        this.$router.push("/login");
      }
      this.showBuy = true;
    },
    payTest() {
      // console.log(localStorage['env']);
      // if (!this.payamount) {
      //   this.showBuy = false;
      //   this.can_create = false;
      // } else {
      const ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) != "micromessenger") {
        // if(localStorage['env'] == 'notWechat'){
        let param = {
          payment: this.alis ? "ali_pay" : "wechat_pay",
          pay_type: "evaluation",
          evaluation: this.eval_id,
          amount: this.payamount,
          inviter_id: this.inviter_id,
        };
        if (this.couponFlag) {
          //这是优惠卷的判断
          param.coupon_id = this.coupon.id;
        }
        h5paychase(param).then((res) => {
          if (res.code == "SUCCESS") {
            console.log(res.data.pay_url);
            // window.location.replace(res.data.pay_url);
            if (res.data.pay_url) {
              window.location.replace(res.data.pay_url);
            }
            // window.location.replace(res.data.pay_url);
            // 添加之前先删除一下，如果单页面，页面不刷新，添加进去的内容会一直保留在页面中，二次调用form表单会出错
            // let divForm = document.getElementsByTagName('divform')
            // 	if (divForm.length) {
            // 	document.body.removeChild(divForm[0])
            // 	}
            // 	const div=document.createElement('divform');
            // 	div.innerHTML=resp.data; // data就是接口返回的form 表单字符串
            // 	document.body.appendChild(div);
            // 	document.forms[0].setAttribute('target', '_blank') // 新开窗口跳转
            // 	document.forms[0].submit();
            // }else{
            // 	this.$alert("错误："+resp.data,"提示",{
            // 		confirmButtonText:'确定'
            // 	});
          }
        });
      } else {
        let param = {
          pay_type: "evaluation",
          evaluation: this.eval_id,
          amount: this.payamount,
          inviter_id: this.inviter_id,
        };
        if (this.couponFlag) {
          param.coupon_id = this.coupon.id;
        }
        paychase(param).then((res) => {
          console.log("paychase的输出", res);
          // console.log(this.payamount)
          if (parseFloat(this.payamount) == parseFloat(0)) {
            setTimeout(() => {
              this.can_create = true;
              this.showBuy = false;
              console.log(this.showCoupon);
            }, 1000);
            // return
          } else {
            console.log("支付", res);
            let data = res.data.pay_params;
            let appId = data.appId;
            let timeStamp = data.timeStamp;
            let nonceStr = data.nonceStr;
            let signature = data.signature;
            let packages = data.package;
            let paySign = data.paySign;
            WeixinJSBridge.invoke(
              "getBrandWCPayRequest",
              {
                appId: appId, //公众号名称，由商户传入
                timeStamp: timeStamp, //时间戳，自1970年以来的秒数
                nonceStr: nonceStr, //随机串
                package: packages,
                signType: "MD5", //微信签名方式：
                paySign: paySign, //微信签名
              },
              (res) => {
                if (res.err_msg == "get_brand_wcpay_request:ok") {
                  setTimeout(() => {
                    this.showBuy = false;
                    this.can_create = true;
                  }, 500);
                } else if (res.err_msg === "get_brand_wcpay_request:cancel") {
                  this.$message({
                    message: "您已取消支付",
                    type: "error",
                  });
                } else {
                  this.$message({
                    message: "支付失败",
                    type: "error",
                  });
                }
              }
            );
          }
        });
      }
    },
    toBottom(i) {
      var clientHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      var scrollHeight = document.documentElement.scrollHeight;
      var height = scrollHeight - clientHeight; //超出窗口上界的值就是底部的scrolTop的值
      document.documentElement.scrollTop += i;
      if (document.documentElement.scrollTop < height) {
        var c = setTimeout(() => this.toBottom(i), 16);
      } else {
        clearTimeout(c);
      }
    },
    // 返回首页
    goHome() {
      this.$router.push("/index");
    },
  },
};
</script>

<style lang="less" scoped>
@import "~Style/index.less";

.saveRes1 {
  position: fixed;

  .pop_tacbox {
    width: 337px;
    // height: 568px;
    // padding-top: 18px;
    // background-color: #fff;
    // position: fixed;
    border-radius: 32px;

    // overflow: hidden;
    .pop_imgbox {
      width: 180px;
      height: 180px;
      border-radius: 254px;
      margin: 0 auto;
      padding-top: 18px;

      img {
        width: 100%;
        height: 100%;
        border-radius: 254px;
      }
    }

    .pop_textTitleBox {
      margin-top: 10px;

      .pop_textTitle {
        font-size: 26px;
        font-weight: bold;
      }
    }

    .pop_testDiscribe {
      line-height: 30px;
      margin-top: 0;
    }

    .light {
      margin-top: 0;
    }

    .code_copy {
      margin: 10px 0;
      .w(237);
    }

    .code_box {
      line-height: 30px;
      position: relative;
    }

    .code_save {
      .w(236);
      height: 46px;
      font-size: 0.48rem;
      color: #fff;
      border-radius: 0.5rem;
      background-color: #42686e;
      line-height: 46px;
      text-align: center;
    }

    .code_save_icon {
      display: inline-block;
      width: 14px;
      height: 100%;
      margin-right: 8px;

      img {
        width: 17px;
        height: 16px;
        border-radius: 0;
        vertical-align: middle;
      }
    }

    .showImgSave {
      .w(337);
      height: 140px;
      background: #d6e6e8;
      border-radius: 32px;
      // border-top-right-radius: 32px;
      position: absolute;
      left: 0;
      bottom: 0;
      box-sizing: border-box;
      padding: 0 24px 0 21px;

      .showImgSave_left_imgbox {
        display: flex;
        align-items: center;

        img {
          width: 36px;
          height: 36px;
          margin-right: 5px;
        }
      }

      .showImgSave_left {
        .w(160);
        height: 100%;
        padding-top: 22px;
        font-size: 12px;
        float: left;

        .left_imgbox_title {
          color: #4a4a4a;
          font: 14px bold;
        }

        .Save_left_text {
          color: #9b9b9b;
          line-height: 18px;
          text-align: left;
          margin-top: 11px;
        }
      }

      .showImgSave_right {
        float: right;
        text-align: center;
        .w(98);
        height: 100%;

        .savePic {
          border-radius: 0;
          width: 100%;
          height: 100%;
          margin-top: 0;
          position: fixed;
        }

        .showImgSave_code {
          color: #42686e;
          font: 18px;
        }
      }
    }
  }

  .ma {
    .w(88px);
    height: 88px;
    border: 3px solid #42686e;
    padding: 4px;
    border-radius: 8px;
    margin-top: 15px;
    margin-bottom: 8px;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .ma {
    .w(88px);
    height: 88px;
    border: 3px solid #42686e;
    padding: 4px;
    border-radius: 8px;
    margin-top: 15px;
    margin-bottom: 8px;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .savePic {
    padding: 0;
  }
}

.collects {
  text-align: center;
  right: 2px;
  display: inline-block;
  width: 65px;
  height: 28px;
  line-height: 28px;
  background: #ffffff;
  border-radius: 2px;
  border: 1px solid #ccc;
  position: absolute;
  top: calc(80vw - 28px);
  font-size: 13px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #4a4a4a;
}

.introduction {
  position: relative;
}
.wx_id {
  // width: 151px;
  // height: 13px;
  font-size: 13px;
  font-family: SourceHanSansCN-Normal, SourceHanSansCN;
  font-weight: 400;
  color: #ffffff;
  line-height: 20px;
  transform: translate(114px, -53px);
}

//    .van-popup {
// 		position: fixed;
// 		max-height: 100%;
// 		overflow-y: auto;
// 		background-color: #fff;
// 	}
.pop {
  // background: #fff;
  border-radius: 24px;

  .tt {
    margin-top: 30px;
    width: 90%;
    margin-left: 5%;
  }

  .pop-img1 {
    width: 8.14rem;
    height: 7.29rem;
    border-radius: 0.5rem;
  }

  .pop-title {
    text-align: center;
    font-size: 0.72rem;
    font-family: SourceHanSansCN-Bold, SourceHanSansCN;
    font-weight: bold;
    color: #4a4a4a;
    line-height: 1.09rem;
    margin-top: 0.65rem;
    margin-bottom: 0.14rem;
  }

  .pop-exc {
    text-align: center;
    font-size: 0.31rem;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
    color: #4a4a4a;
    line-height: 0.41rem;
    letter-spacing: 1px;
    margin-bottom: 0.22rem;
  }

  .pop-imglist {
    text-align: center;
    margin-bottom: 0.25rem;

    img {
      height: 0.92rem;
      width: 0.87rem;
    }
  }

  .popFt {
    height: 2.5rem;
    text-align: center;

    .popbtn {
      width: 80%;
      margin-top: 0.8rem;
      background-color: #f7b270;
      font-weight: bold;
      color: white;
      border-radius: 0.5rem;
    }

    .getCoupon {
      background-color: #42686e;
    }

    .rightIcon {
      width: 20px;
      height: 20px;
      display: inline-block;
      background-color: green;
      border-radius: 10px;
      color: white;
      margin-left: 10px;
    }
  }

  .popbtn {
    width: 80%;
    // margin-left: 10%;
    margin-top: 0.8rem;
    margin-bottom: 0.4rem;
    // font-weight: bold;
    font-size: 18px;
    color: white;
    border-radius: 0.5rem;
  }

  .reduce {
    display: inline-block;
    background: url("./../../../assets/img/test/reduce.png") no-repeat center
      center;
    background-size: 100%, 100%;
    width: 25px;
    height: 25px;
  }

  .reduce-1 {
    display: inline-block;
    background: url("./../../../assets/img/test/reduce-1.png") no-repeat center
      center;
    background-size: 100%, 100%;
    width: 25px;
    height: 25px;
  }

  .number {
    vertical-align: super;
    margin-top: -10px;
    display: inline-block;
    padding: 5px;
  }

  .add {
    display: inline-block;
    background: url("./../../../assets/img/test/add.jpg") no-repeat center
      center;
    background-size: 100%, 100%;
    width: 25px;
    height: 25px;
  }

  img {
    width: 8.8rem;
    height: 7rem;
    border-radius: 0.5rem;
  }

  .code {
    margin: 10px auto 0;
    text-align: center;
    font-weight: bold;
    line-height: 47px;
    letter-spacing: 1.33px;
    .w(237);
    height: 47px;
    background-color: #eceff5;
    border-radius: 18px;
    font-size: 24px;
    font-weight: bold;
  }

  .rightIcon {
    width: 20px;
    height: 20px;
    background-color: green;
    border-radius: 10px;
    color: white;
    position: absolute;
    top: 50%;
    right: 23px;
    transform: translateY(-50%);
    line-height: 20px;
  }
}

.pop1 {
  margin-top: -17px;
  border-radius: 24px;

  .tt {
    margin-top: 30px;
    width: 90%;
    margin-left: 5%;
  }

  .pop-img1 {
    width: 8.14rem;
    // border-radius: 0.5rem;
  }

  .pop-title {
    text-align: center;
    font-size: 0.72rem;
    font-family: SourceHanSansCN-Bold, SourceHanSansCN;
    font-weight: bold;
    color: #4a4a4a;
    // line-height: 1.09rem;
    margin-top: -30px;
    padding-top: 40px;
    padding-bottom: 0.14rem;
    background: #fff;
  }

  .pop-exc {
    text-align: center;
    font-size: 0.31rem;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
    color: #4a4a4a;
    // line-height: 0.41rem;
    letter-spacing: 1px;
    padding-bottom: 14px;
    background: #fff;
  }

  .pop-imglist {
    text-align: center;
    margin-bottom: 0.25rem;
    padding-bottom: 44px;

    img {
      height: 0.92rem;
      width: 0.87rem;
    }
  }

  .closeImg {
    height: 30px;
    width: 30px;
    margin: 0 auto;
  }

  .popFt {
    text-align: center;
    margin-top: -34px;

    margin-bottom: 20px;

    .popbtn {
      width: 80%;
      background-color: #42686e;
      font-weight: bold;
      color: white;
      border-radius: 0.5rem;
      border: none;
    }

    .getCoupon {
      background-color: #42686e;
    }

    .rightIcon {
      width: 20px;
      height: 20px;
      display: inline-block;
      background-color: green;
      border-radius: 10px;
      color: white;
      margin-left: 10px;
    }
  }

  .popbtn {
    width: 80%;
    // margin-left: 10%;
    // font-weight: bold;
    font-size: 18px;
    color: white;
    border-radius: 0.5rem;
  }

  .reduce {
    display: inline-block;
    background: url("./../../../assets/img/test/reduce.png") no-repeat center
      center;
    background-size: 100%, 100%;
    width: 25px;
    height: 25px;
  }

  .reduce-1 {
    display: inline-block;
    background: url("./../../../assets/img/test/reduce-1.png") no-repeat center
      center;
    background-size: 100%, 100%;
    width: 25px;
    height: 25px;
  }

  .number {
    vertical-align: super;
    margin-top: -10px;
    display: inline-block;
    padding: 5px;
  }

  .add {
    display: inline-block;
    background: url("./../../../assets/img/test/add.jpg") no-repeat center
      center;
    background-size: 100%, 100%;
    width: 25px;
    height: 25px;
  }

  img {
    width: 8.8rem;
    height: 7rem;
    border-radius: 0.5rem;
  }

  .code {
    margin: 10px auto 0;
    text-align: center;
    font-weight: bold;
    line-height: 47px;
    letter-spacing: 1.33px;
    .w(237);
    height: 47px;
    background-color: #eceff5;
    border-radius: 18px;
    font-size: 24px;
    font-weight: bold;
  }

  .rightIcon {
    width: 20px;
    height: 20px;
    background-color: green;
    border-radius: 10px;
    color: white;
    position: absolute;
    top: 50%;
    right: 23px;
    transform: translateY(-50%);
    line-height: 20px;
  }
}

.icons {
  position: absolute;
  top: 7.5rem;
  right: 0;
  z-index: 100;

  img {
    width: 0.8rem;
  }

  .invite {
    width: 2rem;
    background-color: #eceff5;
    border-radius: 0.4rem 0 0 0.4rem;
    height: 1rem;
    margin-left: 7px;
    white-space: nowrap;

    img {
      margin-left: 8px;
      vertical-align: middle;
    }

    span {
      margin-left: 5px;
      line-height: 1rem;
    }
  }

  .collect {
    float: right;
    margin-right: 10px;
    margin-top: 10px;
  }
}

.imgbg {
  // background-image: linear-gradient(to bottom,
  //         rgba(0, 0, 0, 0.01),
  //         rgba(0, 0, 0, 0.5));
  // background-image: -ms-linear-gradient(to bottom,
  //         rgba(0, 0, 0, 0.01),
  //         rgba(0, 0, 0, 0.5));
  // background-image: -moz-linear-gradient(linear,
  //         left top,
  //         left bottom,
  //         from(rgba(0, 0, 0, 0.01)),
  //         to(rgba(0, 0, 0, 0.5)));
  // background-image: -webkit-linear-gradient(to bottom,
  //         rgba(0, 0, 0, 0.01),
  //         rgba(0, 0, 0, 0.5));
  // background-image: -o-linear-gradient(to bottom,
  //         rgba(0, 0, 0, 0.2),
  //         rgba(0, 0, 0, 0.5));
  width: 100%;
  height: calc(0.8 * 100vw);
  // margin-top: 10px;
  z-index: 1;
  // margin-left: 5%;
  // border-radius: 0.5rem;

  .head {
    height: calc(0.8 * 100vw);
    pointer-events: none;
    // border-radius: 0.5rem;
    // mix-blend-mode: overlay;
  }
}

img {
  width: 100%;
}

.title {
  // position: absolute;
  // margin-top: -4.5rem;
  width: 95%;
  left: 5%;

  .tit {
    line-height: 0.8rem;
  }
}

.allbtn {
  margin-bottom: 50px;
  width: 90%;
  border-radius: 18px;
  margin-left: 5%;
}

.bottom {
  // height: 50px;
  padding: 3px;
  height: fit-content;
  min-height: 50px;

  line-height: 50px;
  width: 100%;
  bottom: 0;
  border: solid 1px #d8d8d8;
  border-right: none;
  // z-index: 100;
  position: fixed;

  .txt1 {
    width: 30%;
    display: inline-block;
  }

  .txt2 {
    width: 35%;
    display: inline-block;
  }

  .right {
    /*margin-left: 50px;*/
    width: 35%;
    text-align: end;
  }

  .btn {
    width: 30%;
    height: 100%;
    background-color: #f7b270;
    background: linear-gradient(110deg, #f8b776 0%, #fceea8 100%);
    box-shadow: 0px 0px 4px 0px #f9c280;
    border-radius: 8px;
    border: 1px transparent solid !important;
    color: white;
    user-select: none;
  }

  /*.btn:active{*/
  /*width: 30%;*/
  /*height: 100%;*/
  /*color: #f7b270;*/
  /*background: #FFFFFF; */
  /*border: 2px solid #f7b270;*/
  /*  user-select: none;*/
  /*}*/
}

.homeIcon {
  // width: 25px;
  /* border-radius: 50%; */
  /* background: #ffffff9c; */
  /* float: right; */
  right: 10px;
  bottom: 2rem;
  border: none;

  .home {
    width: 25px;
    margin-left: 10%;
    margin-top: 10%;
  }
}

.w90btn {
  height: 50px;
  line-height: 50px;
  width: 90%;
  left: 5%;
  bottom: 10px;
  // z-index: 100;
  font-weight: bold;
  border: none;
  position: fixed;
}

.orange2white {
  color: #f7b270 !important;
  background-image: linear-gradient(
    to right,
    rgba(255, 255, 255, 0),
    rgba(252, 240, 169, 1)
  ) !important;
  background-image: -ms-linear-gradient(
    to right,
    rgba(255, 255, 255, 0),
    rgba(252, 240, 169, 1)
  );
  background-image: -moz-linear-gradient(
    linear,
    left right,
    left right,
    from(rgba(255, 255, 255, 0)),
    to(rgba(252, 240, 169, 1))
  );
  background-image: -webkit-linear-gradient(
    to right,
    rgba(255, 255, 255, 0),
    rgba(252, 240, 169, 1)
  );
  background-image: -o-linear-gradient(
    to right,
    rgba(255, 255, 255, 0),
    rgba(252, 240, 169, 1)
  );
}

.green {
  color: #417505;
}

.none {
  display: none;
}

.saveRes {
  position: fixed;

  .pop_tacbox {
    .w(337);
    // height: 568px;
    // padding-top: 18px;
    // background-color: #fff;
    // position: fixed;
    border-radius: 32px;

    // overflow: hidden;
    .pop_imgbox {
      width: 254px;
      height: 254px;
      border-radius: 254px;
      margin: 0 auto;
      padding-top: 18px;

      img {
        width: 100%;
        height: 100%;
        border-radius: 254px;
      }
    }

    .pop_textTitleBox {
      margin-top: 10px;

      .pop_textTitle {
        font-size: 26px;
        font-weight: bold;
      }
    }

    .pop_testDiscribe {
      line-height: 30px;
      margin-top: 0;
    }

    .light {
      margin-top: 0;
    }

    .code_copy {
      margin: 10px 0;
      .w(237);
    }

    .code_box {
      line-height: 30px;
      position: relative;
    }

    .code_save {
      .w(236);
      height: 46px;
      font-size: 0.48rem;
      color: #fff;
      border-radius: 0.5rem;
      background-color: #42686e;
      line-height: 46px;
      text-align: center;
    }

    .code_save_icon {
      display: inline-block;
      width: 14px;
      height: 100%;
      margin-right: 8px;

      img {
        width: 17px;
        height: 16px;
        border-radius: 0;
        vertical-align: middle;
      }
    }

    .showImgSave {
      .w(337);
      height: 149px;
      background: #d6e6e8;
      border-radius: 32px;
      // border-top-right-radius: 32px;
      position: absolute;
      left: 0;
      bottom: 0;
      box-sizing: border-box;
      padding: 0 24px 0 21px;

      .showImgSave_left_imgbox {
        display: flex;
        align-items: center;

        img {
          width: 42px;
          height: 20px;
          margin-right: 5px;
        }
      }

      .showImgSave_left {
        .w(143);
        height: 100%;
        padding-top: 22px;
        font-size: 12px;
        float: left;

        .left_imgbox_title {
          color: #4a4a4a;
          font: 18px bold;
        }

        .Save_left_text {
          color: #9b9b9b;
          line-height: 18px;
          text-align: left;
          margin-top: 11px;
        }
      }

      .showImgSave_right {
        float: right;
        text-align: center;
        .w(98);
        height: 100%;

        .savePic {
          border-radius: 0;
          width: 100%;
          height: 100%;
          margin-top: 0;
          position: fixed;
        }

        .showImgSave_code {
          color: #42686e;
          font: 18px;
        }
      }
    }
  }
}

.ma {
  .w(88px);
  height: 88px;
  border: 3px solid #42686e;
  padding: 4px;
  border-radius: 8px;
  margin-top: 15px;
  margin-bottom: 8px;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 100%;
    height: 100%;
  }
}

.ma {
  .w(88px);
  height: 88px;
  border: 3px solid #42686e;
  padding: 4px;
  border-radius: 8px;
  margin-top: 15px;
  margin-bottom: 8px;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 100%;
    height: 100%;
  }
}

.savePic {
  padding: 0;
}
</style>
<style lang="less">
.van-popup--bottom.van-popup--round {
  background-color: #fff;
}

.van-popup--center.van-popup--round {
  border-radius: 0;
}

.van-popup--center {
  margin: 0 auto;
}

.rebuyBox {
  /*margin-top: 2px;*/
  display: flex;
  justify-content: space-around;
  margin: 0 30px;
  /*padding: 0px 30px;*/
  width: 100%;

  .rebuy {
    /*margin-left: 30px;*/
    /*width: 40%;*/
    height: 45px;
    margin-top: 5px;
    line-height: 45px;
    border-radius: 30px;
    letter-spacing: 1px;
    padding: 0 30px;
    /*line-height: 18px;*/
    color: white;
    background: linear-gradient(270deg, #fcf0a9 0%, #f5a623 100%);
    font-size: 18px !important;
    font-weight: 500;

    .ogPrice {
      margin-left: 1px;
      text-decoration: line-through;
      font-size: 12px;
      margin-right: 2px;
    }
  }

  .viewReport {
    /*width: 30%;*/
    color: white;
    border-radius: 30px;
    background: rgba(116, 135, 195, 1);
    padding: 0 30px;
  }
}
</style>
